"use client";

import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AppBannerStore {
	isDismissed: boolean;
	dismissedAt: string | null;
	dismissBanner: () => void;
	resetBanner: () => void;
	shouldShowBanner: () => boolean;
}

export const useAppBannerStore = create<AppBannerStore>()(
	persist(
		(set, get) => ({
			isDismissed: false,
			dismissedAt: null,

			dismissBanner: () => {
				set({
					isDismissed: true,
					dismissedAt: new Date().toISOString(),
				});
			},

			resetBanner: () => {
				set({
					isDismissed: false,
					dismissedAt: null,
				});
			},

			shouldShowBanner: () => {
				const { isDismissed, dismissedAt } = get();

				// Don't show if dismissed
				if (isDismissed) {
					// Reset after 30 minutes
					if (dismissedAt) {
						const dismissedDate = new Date(dismissedAt);
						const minutesSinceDismissed =
							(Date.now() - dismissedDate.getTime()) / (1000 * 60);
						if (minutesSinceDismissed > 30) {
							get().resetBanner();
							return true;
						}
					}
					return false;
				}

				return true;
			},
		}),
		{
			name: "app-download-banner",
			partialize: (state) => ({
				isDismissed: state.isDismissed,
				dismissedAt: state.dismissedAt,
			}),
		},
	),
);
